import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/system';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import { PieChart } from 'src/components/charts';

export default function MultipleInputCard({ question }) {
  const { isSmallScreen } = useResponsiveScreen();
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Stack
        direction="row"
        alignItems="flex-start"
        px={2}
        justifyContent="space-between"
        gap={2}
      >
        <Typography
          variant="subtitle1"
          sx={{
            mb: 0.5,
            fontSize: isSmallScreen ? '0.8rem' : '1rem',
            fontWeight: 'bold',
            flex: 1,
            minWidth: 200,
            wordBreak: 'break-word',
          }}
        >
          {question.questionText}
        </Typography>

        <Typography
          variant="caption"
          color="info.dark"
          sx={{ whiteSpace: 'nowrap', alignSelf: 'flex-start' }}
        >
          {t(`surveyDashboard.${question.questionType}`)}
        </Typography>
      </Stack>

      <PieChart
        chartData={Object.entries(question.responseCount || {}).map(([label, value]) => ({
          label,
          value,
        }))}
        chartColors={[
          theme.palette.primary.main,
          theme.palette.error.main,
          theme.palette.warning.main,
          theme.palette.success.main,
        ]}
        height={145}
        noMarginTop
      />
    </Box>
  );
}

MultipleInputCard.propTypes = {
  question: PropTypes.object,
};
